import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Loader2, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json();
        setError(data.detail || 'Something went wrong');
      }
    } catch {
      setError('Failed to connect. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FFF8F0' }}>
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <img src="/hibff-logo.png" alt="HiBFF" className="mx-auto mb-4" style={{ height: 96, width: 'auto' }} />
          <h1 className="text-2xl font-bold" style={{ color: '#1A1209' }}>Reset Your Password</h1>
          <p className="text-sm mt-1" style={{ color: '#666' }}>Enter your email and we&apos;ll send you a reset link</p>
        </div>

        {sent ? (
          <div className="bg-white rounded-xl p-8 text-center" style={{ border: '1px solid #E0E0E0' }} data-testid="reset-sent-message">
            <CheckCircle size={48} className="mx-auto mb-4" style={{ color: '#2EAA5C' }} />
            <h2 className="text-lg font-bold mb-2" style={{ color: '#1A1209' }}>Check Your Email</h2>
            <p className="text-sm mb-6" style={{ color: '#666' }}>
              If an account exists for <strong>{email}</strong>, we&apos;ve sent a password reset link. It expires in 1 hour.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-white text-sm font-medium" style={{ backgroundColor: '#F5831F' }} data-testid="back-to-login-btn">
              <ArrowLeft size={16} /> Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-white rounded-xl p-8" style={{ border: '1px solid #E0E0E0' }} data-testid="forgot-password-form">
            {error && <div className="mb-4 p-3 rounded-lg text-sm bg-red-50 text-red-700" data-testid="forgot-error">{error}</div>}
            <div className="mb-5">
              <label className="text-sm font-medium mb-1.5 block" style={{ color: '#333' }}>Email Address</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#999' }} />
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="w-full pl-10 pr-4 py-3 rounded-lg border text-sm"
                  style={{ borderColor: '#E0E0E0' }}
                  data-testid="forgot-email-input"
                />
              </div>
            </div>
            <button type="submit" disabled={loading || !email} className="w-full py-3 rounded-lg text-white text-sm font-medium disabled:opacity-50" style={{ backgroundColor: '#F5831F' }} data-testid="forgot-submit-btn">
              {loading ? <Loader2 size={16} className="animate-spin mx-auto" /> : 'Send Reset Link'}
            </button>
            <div className="text-center mt-4">
              <Link to="/login" className="text-sm font-medium" style={{ color: '#F5831F' }}>Back to Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
